import { GenIcon } from '../helpers/IconBase.es.js';

const DirectionAlternativeOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M4.61909 11.6085C3.35698 11.0475 3.45956 9.2233 4.7766 8.80739L17.2493 4.86865C18.4072 4.503 19.497 5.59284 19.1314 6.75072L15.1926 19.2234C14.7767 20.5404 12.9525 20.643 12.3915 19.3809L10.3124 14.7029C10.1113 14.2505 9.74953 13.8887 9.29707 13.6876L4.61909 11.6085Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { DirectionAlternativeOutlined };
